/* 🤖 this file was generated by svg-to-ts */
export const siriusHouse: {
  name: 'house';
  data: string;
} = {
  name: 'house',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.989 2.905a1.5 1.5 0 0 1 2.022 0l.002.001L20.51 9.72l.01.01A1.528 1.528 0 0 1 21 10.816V19.5a1.5 1.5 0 0 1-1.5 1.5H15a1.5 1.5 0 0 1-1.5-1.5V15h-3v4.5A1.5 1.5 0 0 1 9 21H4.5A1.5 1.5 0 0 1 3 19.5v-8.684a1.529 1.529 0 0 1 .479-1.086l.01-.01 7.499-6.814Zm-6.482 7.917 7.491-6.808.002-.001.002.001 7.49 6.808a.028.028 0 0 1 .008.016V19.5H15V15a1.5 1.5 0 0 0-1.5-1.5h-3A1.5 1.5 0 0 0 9 15v4.5H4.5v-8.662a.028.028 0 0 1 .007-.016Z" fill="currentColor"/></svg>`
};
